import { gql } from '@/__generated__';
import { useQueryTypeahead } from '@/components/use-query-typeahead';

const UsersTypeaheadQuery = gql(`
query UsersTypeaheadQuery($query: String!, $limit: Int = 10, $offset: Int = 0) {
  typeahead(input: {text: $query, limit: $limit, offset: $offset, type: [User], followingFirst: false, paidFirst: false}) {
    users {
      ...UserCardFragment
    }
    offset
  }
}
`);

export const useUsersTypeahead = () => {
  const { data, ...rest } = useQueryTypeahead(UsersTypeaheadQuery, true);
  return {
    users: data?.typeahead.users,
    ...rest,
  };
};
